module.exports = __webpack_public_path__ + "helveticaltstd-roman-webfont.1fc2a33d07e003095250.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/helveticaltstd-roman-webfont.woff
// module id = ../../../../../src/assets/fonts/helveticaltstd-roman-webfont.woff
// module chunks = styles